import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from '../../components/LoadableLoading';
import { ILoadedProps, ILoaderProps, IProps } from './interfaces';

export const path = '/checklist/list';

const PageChecklistRegister: React.FC<IProps> = (props) => {
  const loader: ILoaderProps = {
    page: () => import(`./page`),
    i18n: () => import(`./ru.json`),
  };

  const LoadableMap = Loadable.Map({
    loader,
    loading: LoadableLoading,
    render(loaded: ILoadedProps, loadedProps: {}) {
      const Page: any = loaded.page.default;

      return <Page {...loadedProps} {...props} i18n={{ ...loaded.i18n }} />;
    },
  });

  return <LoadableMap {...props} />;
};

export default PageChecklistRegister;
